module.exports = __webpack_public_path__ + "static/media/0222_Small.e73d2fb4.jpg";